/* LINDEN Everyday – one complimentary pillowcase for eligible orders.
   Native Shopify automatic Buy X Get Y discount is the pricing authority.
   The script never keeps a gift item in the cart unless Shopify prices it at zero. */
(function(){
  'use strict';
  if(window.__lindenEverydayGiftLoaded)return;
  window.__lindenEverydayGiftLoaded=true;
  var EVERYDAY=16178392629580;
  var GIFT=59029769257292;
  var MIN=10000;
  var KEY='_LINDEN Geschenk';
  var VALUE='Everyday ab 100 EUR';
  var originalFetch=window.fetch.bind(window);
  var root=((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/').replace(/\/?$/,'/');
  var active=false,timer=null,pending=false;
  var paths={cart:root+'cart.js',add:root+'cart/add.js',change:root+'cart/change.js'};
  function nativeJSON(path,method,data){
    return originalFetch(path,{method:method||'GET',credentials:'same-origin',cache:'no-store',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:data?JSON.stringify(data):undefined
    }).then(function(response){
      if(!response.ok)throw new Error('Cart request '+response.status);
      return response.json();
    });
  }
  function ownedGift(item){
    return Number(item.variant_id)===GIFT&&item.properties&&item.properties[KEY]===VALUE;
  }
  function eligibleValue(cart){
    return (cart.items||[]).reduce(function(sum,item){
      if(Number(item.product_id)!==EVERYDAY)return sum;
      return sum+Number(item.final_line_price||0);
    },0);
  }
  function onCartPage(){
    return /\/cart\/?$/.test(window.location.pathname);
  }
  function isCartMutation(input,options){
    var url=typeof input==='string'?input:(input&&input.url)||'';
    var method=String((options&&options.method)||(input&&input.method)||'GET').toUpperCase();
    try{
      var pathname=new URL(url,window.location.href).pathname;
      return method!=='GET'&&/\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(pathname);
    }catch(e){return false;}
  }
  function schedule(delay){
    if(timer)clearTimeout(timer);
    timer=setTimeout(function(){timer=null;sync();},delay||150);
  }
  function refreshIfCart(changed){
    if(changed&&onCartPage())window.location.reload();
    if(changed)window.dispatchEvent(new CustomEvent('linden:gift-cart-updated'));
  }
  async function sync(){
    if(active){pending=true;return;}
    active=true;
    var changed=false;
    try{
      var cart=await nativeJSON(paths.cart);
      var qualified=eligibleValue(cart)>=MIN;
      var allGift=(cart.items||[]).filter(function(i){return Number(i.variant_id)===GIFT;});
      var ours=allGift.filter(ownedGift);
      if(!qualified&&ours.length){
        for(var i=0;i<ours.length;i++){
          await nativeJSON(paths.change,'POST',{id:ours[i].key,quantity:0});
          changed=true;
        }
      }else if(qualified&&!allGift.length){
        await nativeJSON(paths.add,'POST',{items:[{id:GIFT,quantity:1,properties:{'_LINDEN Geschenk':VALUE}}]});
        var after=await nativeJSON(paths.cart);
        var created=(after.items||[]).find(ownedGift);
        if(created){
          if(Number(created.final_line_price)===0){changed=true;}
          else{
            await nativeJSON(paths.change,'POST',{id:created.key,quantity:0});
            window.dispatchEvent(new CustomEvent('linden:gift-discount-unavailable'));
          }
        }
      }else if(ours.length&&ours.some(function(i){return Number(i.final_line_price)>0;})){
        for(var j=0;j<ours.length;j++){
          if(Number(ours[j].final_line_price)>0){
            await nativeJSON(paths.change,'POST',{id:ours[j].key,quantity:0});
            changed=true;
          }
        }
      }
      refreshIfCart(changed);
    }catch(e){
      // Never block an ordinary purchase due to gift fulfillment errors.
      window.dispatchEvent(new CustomEvent('linden:gift-error'));
    }finally{
      active=false;
      if(pending){pending=false;schedule(150);}
    }
  }
  window.fetch=function(input,options){
    var mutation=isCartMutation(input,options);
    return originalFetch.apply(window,arguments).then(function(response){
      if(mutation&&response.ok)schedule(150);
      return response;
    });
  };

  /* Cart-page gift Quick Add: only adds the item via the verified-free gift sync.
     If Shopify does not apply the discount, the sync immediately removes it again. */
  document.addEventListener('click',function(event){
    var button=event.target.closest&&event.target.closest('[data-linden-gift-add]');
    if(!button)return;
    event.preventDefault();
    if(button.disabled)return;
    button.disabled=true;
    button.textContent='GESCHENK WIRD GEPRÜFT …';
    var card=button.closest('[data-linden-gift-card]');
    var message=card&&card.querySelector('[data-linden-gift-message]');
    if(message)message.textContent='Wir prüfen deinen kostenlosen Kissenbezug im Warenkorb.';
    sync().then(function(){
      return nativeJSON(paths.cart);
    }).then(function(cart){
      var gift=(cart.items||[]).find(function(item){
        return Number(item.variant_id)===GIFT&&Number(item.final_line_price)===0;
      });
      if(gift){
        if(onCartPage())window.location.reload();
        else{
          button.textContent='✓ GESCHENK HINZUGEFÜGT';
          if(message)message.textContent='Dein Kissenbezug ist mit 0,00 € im Warenkorb.';
        }
      }else{
        button.disabled=false;
        button.textContent='+ GESCHENK GRATIS HINZUFÜGEN';
        if(message)message.textContent='Der Gratisrabatt konnte noch nicht bestätigt werden. Bitte prüfe deinen Everyday-Warenwert ab 100 €.';
      }
    }).catch(function(){
      button.disabled=false;
      button.textContent='+ GESCHENK GRATIS HINZUFÜGEN';
      if(message)message.textContent='Das Hinzufügen hat nicht geklappt. Bitte versuche es erneut.';
    });
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){schedule(300);});
  else schedule(300);
  window.addEventListener('pageshow',function(event){if(event.persisted)schedule(300);});
  document.addEventListener('visibilitychange',function(){if(!document.hidden)schedule(300);});
})();
